export const getActiveClass = (baseclassname, checked, checkedclassname) => {
  let active = checked ? " " + checkedclassname : "";

  return baseclassname + active;
};
